// @flow
import React from 'react';
import './LastOrderInfoSkeleton.css';

const LastOrderInfoSkeleton = () => (
  <div className="last-order-skeleton-main">
    <div className="last-order-skeleton-header">
      <div className="last-order-skeleton-header-line last-order-skeleton-header-line--short skeleton-block" />
      <div className="last-order-skeleton-header-title skeleton-block" />
      <div className="last-order-skeleton-header-line last-order-skeleton-header-line--long skeleton-block" />
    </div>
    <div className="last-order-skeleton-container">
      <div className="last-order-skeleton-info-text skeleton-block" />
      <div className="last-order-skeleton-tracker">
        {[0, 1, 2, 3, 4].map(i => (
          <div key={i} className="last-order-skeleton-tracker-step">
            <div className="last-order-skeleton-tracker-circle skeleton-block" />
            <div className="last-order-skeleton-tracker-label skeleton-block" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default LastOrderInfoSkeleton;
